
import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import '../styles/contact-network.css';

const ContactNetwork = () => {
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const contactData = [
    {
      id: 1,
      question: "Partnerships",
      details: "I need a space for my event...",
      icon: "material-symbols:location-on",
      contacts: [
        { name: "Partnerships responsible for that event", role: "Partnerships", color: "blue" },
        { name: "Pedro Jordão", role: "Head of Partnerships", color: "orange" }
      ]
    },
    {
      id: 2,
      question: "Education",
      details: "I need to contact a university...",
      icon: "material-symbols:school",
      contacts: [
        { name: "Débora Arrais", role: "Head of Education", color: "orange" }
      ]
    },
    {
      id: 3,
      question: "Projects & Causes",
      details: "I have an amazing idea for a project...",
      icon: "ph:hand-heart-fill",
      contacts: [
        { name: "Maria Rita Costa", role: "Treasurer and Head of Projects & Causes", color: "green" },
      ]
    },
    {
      id: 4,
      question: "Human Resources",
      details: "I want to have a follow-up meeting...",
      icon: "material-symbols:groups",
      contacts: [
        { name: "HR responsible for your department", role: "Human Resources", color: "blue" },
        { name: "Raquel Barreto", role: "Head of Human Resources", color: "orange" },
        { name: "Ricardo Toscanelli", role: "Vice President", color: "green" },
      ]
    },
    {
      id: 5,
      question: "Events Organization",
      details: "I have questions about an event...",
      icon: "material-symbols:help",
      contacts: [
        { name: "Head of Event's Department:", role: "", color: "orange" },
        { name: "Beatriz Pinto", role: "Head of Parties and Entertainment", color: "orange" },
        { name: "Matilde Gomes", role: "Head of Integration & Culture Events", color: "orange" },
        { name: "Miguel Florêncio", role: "Head of Sports and Strips", color: "orange" },
        { name: "Maria Rita Costa", role: "Head of Projects & Causes", color: "orange" },
        { name: "Maria Inês Sousa", role: "Events Manager", color: "green" }
      ]
    },
    {
      id: 6,
      question: "Treasury & Reimbursements",
      details: "I have questions about reimbursements or budgets...",
      icon: "material-symbols:payments",
      contacts: [
        { name: "Francisco Fernades", role: "Treasurer", color: "green" }
      ]
    },
    {
      id: 7,
      question: "General Assembly",
      details: "I have questions about the general assembly...",
      icon: "material-symbols:gavel",
      contacts: [
        { name: "Inês Lopes, Sofia Poças, Diogo Jorge", role: "MAG", color: "pink" },
        { name: "Francisca Caruso, Carolina Minhós, Rodrigo Teixeira", role: "Audit Team", color: "pink" }
      ]
    },
    {
      id: 8,
      question: "Important Details",
      details: "I have doubts about association processes, minimum requirements or complaints...",
      icon: "material-symbols:policy",
      contacts: [
        { name: "Francisca Caruso, Carolina Minhós, Rodrigo Teixeira", role: "Audit Team", color: "pink" }
      ]
    },
    {
      id: 9,
      question: "It Support",
      details: "I have questions about this or other IT projects and technologies...",
      icon: "material-symbols:computer-outline",
      contacts: [
        { name: "Diogo Cosme", role: "Head of IT", color: "orange" }
      ]
    }
  ];

  const handleQuestionClick = (question) => {
    setSelectedQuestion(question);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedQuestion(null);
  };

  return (
    <div className="contact-network">
      <div className="questions-grid">
        {contactData.map((item) => (
          <div
            key={item.id}
            className="question-box"
            onClick={() => handleQuestionClick(item)}
          >
            <div className="question-icon">
              <Icon icon={item.icon} />
            </div>
            <div className="question-content">
              <h4>{item.question}</h4>
              <p className="question-details">{item.details}</p>
            </div>
            <div className="click-indicator">
              <Icon icon="material-symbols:arrow-forward" />
            </div>
          </div>
        ))}
      </div>

      {showModal && selectedQuestion && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{selectedQuestion.question}</h3>
              <button className="close-button" onClick={closeModal}>
                <Icon icon="material-symbols:close" />
              </button>
            </div>
            <div className="modal-body">
              <p className="modal-details">{selectedQuestion.details}</p>
              <div className="contacts-list">
                <h4>Contact these people:</h4>
                {selectedQuestion.contacts.map((contact, index) => (
                  <div key={index} className={`contact-card ${contact.color}`}>
                    <div className="contact-info">
                      <h5>{contact.name}</h5>
                      <p>{contact.role}</p>
                    </div>
                    <div className="contact-action">
                      <Icon icon="majesticons:fish-line" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactNetwork;
